import axios from 'axios';
import { APP_URL, REACT_APP_X_API_KEY, HOST_TYPE, REACT_APP_AL_X_API_KEY } from './apiPath';
import { getStoredUser } from '../utils/storage';
import { getLocalTimeZone } from './commonService';

const aiCreateApiInstance = (baseURL) => {
    const api = axios.create({
        baseURL,
    });

    api.interceptors.request.use(
        (config) => {
            // const currentUser = getStoredUser();
            config.headers['x-api-key'] = REACT_APP_AL_X_API_KEY;
            config.headers['timezone'] = getLocalTimeZone();
            config.headers['hosttype'] = HOST_TYPE;
            config.headers['language'] = localStorage.getItem('i18nextLng');
            config.headers['Accept-Language'] = localStorage.getItem('i18nextLng');
            config.headers['ip'] = localStorage.getItem('userIP');
            config.headers['device'] = navigator.userAgent;
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    api.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;

            if (error.response &&
                (error.response.status === 401 || error.response.status === 409) && !originalRequest._retry) {
                originalRequest._retry = true;
                const currentUser = getStoredUser();
                if (currentUser?.token) {
                    try {
                        const refreshResponse = await axios.get(
                            `${ APP_URL }/refresh-token`,
                            {
                                headers: {
                                    'Authorization': `Bearer ${ currentUser.token }`,
                                    'x-api-key': REACT_APP_X_API_KEY,
                                    'hosttype': HOST_TYPE, 
                                    'ip': localStorage.getItem('userIP'), 
                                    'device': navigator.userAgent,
                                    'timezone': getLocalTimeZone()
                                },
                            }
                        );

                        const newToken = refreshResponse.data.token;

                        if (sessionStorage.getItem('user')) {
                            sessionStorage.setItem('user', JSON.stringify({ ...currentUser, token: newToken }));
                        } else {
                            localStorage.setItem('user', JSON.stringify({ ...currentUser, token: newToken }));
                        }

                        originalRequest.headers['token'] = newToken;

                        return api(originalRequest);
                    } catch (e) {
                        console.error('Token refresh failed');
                    }
                }
            }
            return Promise.reject(error);
        }
    );

    return api;
};

export default aiCreateApiInstance;